import React from 'react';
import { createPortal } from 'react-dom';
import './style.scss';

export const FullscreenPreview: React.FC<{ onClose: () => void }> = ({ children, onClose }) => {
  return createPortal(
    <div
      id={Math.random().toString(10)}
      className="general-fullscreen-preview-host"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          // элемент, по которому кликнули === элемент, на котором задали onClick
          onClose();
        }
      }}
    >
      {children}
    </div>,

    document.body,
  );
};
